// Session-level cache for digital assets responses
export const digitalAssetsCache = new Map<string, any>();

export function buildDigitalAssetsCacheKey(params: Record<string, any>): string {
  return JSON.stringify(params, Object.keys(params).sort());
}

export function getDigitalAssetsCache(key: string): any | undefined {
  return digitalAssetsCache.get(key);
}

export function setDigitalAssetsCache(key: string, data: any): void {
  digitalAssetsCache.set(key, data);
}

export function clearDigitalAssetsCache() {
  digitalAssetsCache.clear();
}
